/** 고객 구분·출처 셀렉트 옵션 (API에는 value 문자열 그대로 저장). */

export const CUSTOMER_SEGMENT_OPTIONS = [
  { value: '', label: '선택 안 함' },
  { value: '신규', label: '신규' },
  { value: '기존', label: '기존' },
  { value: 'VIP', label: 'VIP' },
  { value: '가망', label: '가망' },
  { value: '계약', label: '계약' },
  { value: '휴면', label: '휴면' },
  { value: '법인', label: '법인' },
  { value: '개인', label: '개인' },
]

export const CUSTOMER_SOURCE_OPTIONS = [
  { value: '', label: '선택 안 함' },
  { value: '지인소개', label: '지인 소개' },
  { value: '랜딩/웹', label: '랜딩·웹' },
  { value: '전화인입', label: '전화 인입' },
  { value: '광고', label: '광고' },
  { value: '행사/박람회', label: '행사·박람회' },
  { value: 'SNS', label: 'SNS' },
  { value: '기존고객소개', label: '기존 고객 소개' },
  { value: '설문/분석', label: '설문·분석 연동' },
  { value: '기타', label: '기타' },
]

/** 목록에 없는 저장값이 있으면 맨 아래에 한 줄 추가해 선택 유지 */
export function segmentOptionsForStored(stored) {
  const s = (stored ?? '').trim()
  const base = [...CUSTOMER_SEGMENT_OPTIONS]
  if (s && !base.some((o) => o.value === s)) {
    base.push({ value: s, label: `${s} (기존 저장값)` })
  }
  return base
}

export function sourceOptionsForStored(stored) {
  const s = (stored ?? '').trim()
  const base = [...CUSTOMER_SOURCE_OPTIONS]
  if (s && !base.some((o) => o.value === s)) {
    base.push({ value: s, label: `${s} (기존 저장값)` })
  }
  return base
}
